/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { TabView, Tab } from '@react/react-spectrum/TabView';
import TranslationUtil from '../../utils/translation';

import './appInformation.scss';

const ACTION_HANDLER_TYPES = {
    TAB_SELECT: 'tab-select',
};

function getValidCurrentPlatform(tabItems, currentPlatform) {
    return tabItems.find(item => item.tabId === currentPlatform);
}

const renderFailingSpecsList = failingSpecsList => (
    <div className="compatibility-failing-specs-section">
        <ul className="failing-specs-list">
            {failingSpecsList.map(specString => (<li className="failing-specs-list-item">{specString}</li>))}
        </ul>
    </div>
);

const Compatibility = (props) => {
    let tabContent;
    const { data: { tabData } } = props;

    let selectedPlatform;
    if (tabData.currentPlatform) {
        selectedPlatform = getValidCurrentPlatform(
            tabData.tabItems, tabData.currentPlatform
        );
    }
    if (selectedPlatform) {
        tabContent = <div className="compatibility-content" dangerouslySetInnerHTML={{ __html: selectedPlatform.tabContent }} />;
    } else {
        const renderTabList = tabData.tabItems.map(platform => (
            <Tab key={platform.tabTitle} className="compatibility-sub-tab" label={platform.tabTitle}>
                <div className="compatibility-sub-tab-content" dangerouslySetInnerHTML={{ __html: platform.tabContent }} />
            </Tab>
        ));

        tabContent = (
            <TabView
                className="compatibility-tab-view"
                onSelect={(itemNum) => {
                    props.actionHandler(
                        {},
                        ACTION_HANDLER_TYPES.TAB_SELECT,
                        tabData.tabItems[itemNum],
                    );
                }}>
                {renderTabList}
            </TabView>
        );
    }
    return (
        <div className="tab-content">
            <h1 className="tab-title">{TranslationUtil.getMessage(`ccx.app-info-dialog.${tabData.tabId}`)}</h1>
            {
                tabData.failingSpecsList.length > 0
                && renderFailingSpecsList(tabData.failingSpecsList)
            }
            {tabContent}
        </div>
    );
};
export default Compatibility;
